import {DailyGameConfig} from '@/stores/DailyGameStore/DailyGameStore.types';

import {RealRandom} from '@/utils/random/RealRandom';

export class DailyGameMocks {
  private cipher: string;
  public config: DailyGameConfig;

  constructor() {
    const cipherConfig = new RealRandom().choice(DAILY_GAME_CIPHERS_POOL);
    this.cipher = cipherConfig.cipher;
    this.config = {
      keyboardSymbols: cipherConfig.keyboardSymbols,
      reward: 10000,
      cta: {
        text: 'Посмотреть подсказку',
        link: 'https://www.tbank.ru/invest/pulse/?utm_source=xsell&utm_campaign=clicker24&utm_term=task2',
        deeplink: 'tcsgames://https://google.com/',
        investDeeplink: 'tcsgames://https://google.com/',
      },
      cipherLength: cipherConfig.cipher.length,
      mocksTip: cipherConfig.tip,
    };
  }

  public isCipherHasString(str: string): boolean {
    return this.cipher.toLocaleLowerCase().startsWith(str.toLocaleLowerCase());
  }

  public isValidFullCipher(cipher: string): boolean {
    return this.isCipherHasString(cipher) && cipher.length === this.config.cipherLength;
  }
}

const DAILY_GAME_CIPHERS_POOL: {
  cipher: string;
  keyboardSymbols: string[];
  tip: string;
}[] = [
  {
    cipher: 'GMKN',
    keyboardSymbols: ['G', 'T', 'K', 'N', 'M', 'V', 'Y', 'L', 'E'],
    tip: 'Привет, космоинвесторы!\n\nПролетая над северным городом, заметила букву Н из драгоценных металлов. Местные хвастаются никелевыми гамаками. Похоже, нашла компанию-алхимика! Трейдеры зовут ее Гамаком или Норкой. Догадаетесь, какой тикер у этой компании?',
  },
  {
    cipher: 'LKOH',
    keyboardSymbols: ['Q', 'H', 'K', 'N', 'M', 'O', 'R', 'L', 'W'],
    tip: 'Салют, космотрейдеры!\n\nСегодня я пролетала мимо заправочной станции и заметила, что некоторые акции умеют «заправлять» не только машины, но и инвестиционные портфели. Говорят, одна нефтяная компания особенно хороша в этом деле. У нее даже логотип похож на каплю топлива. Догадаетесь, какой тикер у этой компании?',
  },
  {
    cipher: 'SPCE',
    keyboardSymbols: ['E', 'T', 'H', 'P', 'G', 'O', 'C', 'Q', 'S'],
    tip: 'Салют, звездные инвесторы!\n\nСегодня я пролетала мимо космодрома и заметила необычный корабль. Говорят, его построила компания, которая мечтает отправлять туристов в космос. Трейдеры шепчутся, что ее акции — настоящая Галя среди космических стартапов. Догадаетесь, какой тикер у этой компании?',
  },
  {
    cipher: 'LUV',
    keyboardSymbols: ['V', 'T', 'H', 'U', 'K', 'L', 'X', 'S', 'O'],
    tip: 'Привет, космотрейдеры!\n\nПролетая мимо Техаса, я заметила забавную вещь. Говорят, там есть авиакомпания Southwest Airlines, которая буквально излучает любовь. И это не просто красивые слова — даже ее биржевой тикер намекает на это чувство. Какой у нее тикер?',
  },
  {
    cipher: 'BUD',
    keyboardSymbols: ['G', 'U', 'Z', 'N', 'D', 'W', 'S', 'I', 'B'],
    tip: 'Привет, космоинвесторы!\n\nСегодня я пролетала мимо огромной компании, которая производит прохладительные напитки по всей галактике. Говорят, ее продукцию можно найти в каждом баре от Земли до Марса! Трейдеры шепчутся, что ее тикер — это первые три буквы от названия знаменитого чешского бренда, который теперь принадлежит корпорации Anheuser-Busch InBev. Догадаетесь, какой тикер у этого напиточного гиганта?',
  },
  {
    cipher: 'HOG',
    keyboardSymbols: ['J', 'O', 'E', 'H', 'X', 'P', 'G', 'M', 'Y'],
    tip: 'Привет, космоинвесторы!\n\nСегодня я пролетала мимо одной необычной планеты. Там все ездят на космических мотоциклах, которые издают забавные звуки. Местные называют их хрюшками. Говорят, эти мотоциклы выпускает компания, чей тикер созвучен с этим прозвищем. Сможете отгадать, о каком тикере речь?',
  },
  {
    cipher: 'GEEK',
    keyboardSymbols: ['K', 'R', 'E', 'O', 'A', 'G', 'T', 'B', 'E'],
    tip: 'Здравствуйте, космоинвесторы!\n\nСегодня я пролетала мимо одной необычной планеты. Там все жители носят очки, обожают компьютеры и постоянно говорят о каких-то битах и байтах. А еще у них есть своя интернет-компания Internet America с очень забавным тикером. Что это за тикер?',
  },
  {
    cipher: 'BOOM',
    keyboardSymbols: ['R', 'M', 'Z', 'O', 'N', 'D', 'J', 'O', 'B'],
    tip: 'Привет, звездные инвесторы!\n\nПролетая над американскими заводами, я заметила компанию, которая творит настоящие чудеса с металлами. Говорят, она умеет соединять разные материалы так крепко, что их не разделит даже сила черной дыры! Трейдеры шепчутся, что ее тикер напоминает звуковой эффект из комиксов. Догадаетесь, что же за тикер у этой инженерной компании?',
  },
  {
    cipher: 'YDEX',
    keyboardSymbols: ['T', 'D', 'U', 'E', 'M', 'I', 'X', 'Y', 'P'],
    tip: 'Привет, космоинвесторы!\n\nСегодня, бороздя просторы Рунета, я наткнулась на удивительную компанию. Представьте себе: она и поисковик, и такси вызовет, и еду привезет! А еще говорят, что у нее есть какая-то загадочная Алиса. Не робот, а целый помощник! Что за тикер у этой компании?',
  },
  {
    cipher: 'OZON',
    keyboardSymbols: ['Y', 'Z', 'F', 'H', 'O', 'K', 'O', 'W', 'N'],
    tip: 'Привет, космотрейдеры!\n\nПролетая над Россией, я заметила компанию, которая прямо-таки излучает энергию. Говорят, она может доставить что угодно и куда угодно, хоть на Марс! А ее фирменные коробки узнает даже инопланетянин. Трейдеры шепчутся, что ее тикер созвучен с названием одного благородного газа. Не кислород, не азот... Догадаетесь, какой тикер у этого российского гиганта электронной коммерции?',
  },
  {
    cipher: 'TATN',
    keyboardSymbols: ['K', 'T', 'E', 'Y', 'N', 'O', 'S', 'A', 'T'],
    tip: 'Привет, космотрейдеры!\n\nПролетая над Республикой Татарстан, я заметила компанию, которая буквально качает энергию из-под земли. Говорят, без ее нефти не заведется ни один космолет! А еще шепчутся, что ее тикер — это сокращенное название республики, где она «прописана», только с удвоенной последней буквой. Догадаетесь, какой тикер у этого нефтяного гиганта из Казани?',
  },
  {
    cipher: 'WOOF',
    keyboardSymbols: ['T', 'O', 'B', 'Q', 'O', 'W', 'Y', 'F', 'L'],
    tip: 'Привет, космоинвесторы!\n\nСегодня, пролетая над Америкой, я заметила компанию, которая заботится о наших четвероногих друзьях. Говорят, у них есть все: от космических поводков до межгалактических лакомств для питомцев! Трейдеры шутят, что ее тикер — это не просто набор букв, а самый настоящий собачий лай. Догадаетесь, какой тикер у этой компании, которая делает хвосты счастливыми, а инвесторов — довольными?',
  },
  {
    cipher: 'MOO',
    keyboardSymbols: ['B', 'O', 'M', 'W', 'Z', 'K', 'L', 'D', 'O'],
    tip: 'Привет, космотрейдеры!\n\nСегодня, пролетая над зелеными пастбищами, я заметила необычный биржевой инструмент. Говорят, он собрал под одной крышей целое стадо компаний, связанных с сельским хозяйством и производством продуктов питания. Трейдеры шутят, что его тикер — это не просто набор букв, а самый настоящий звук, который издает главная звезда молочной индустрии. Догадаетесь, какой тикер у этого «мычащего» ETF?',
  },
  {
    cipher: 'GAZP',
    keyboardSymbols: ['F', 'Z', 'Y', 'G', 'I', 'B', 'P', 'K', 'A'],
    tip: 'Привет, космотрейдеры!\n\nПролетая над бескрайними просторами России, я заметила компанию, которая может обогреть целую галактику. Говорят, ее трубы тянутся от Сибири до самой Европы! Трейдеры шепчутся, что ее тикер совпадает с первыми четырьмя буквами названия компании на английском. Догадаетесь, какой тикер у этого российского газового гиганта?',
  },
  {
    cipher: 'SGZH',
    keyboardSymbols: ['G', 'S', 'E', 'I', 'D', 'H', 'Z', 'A', 'J'],
    tip: 'Привет, космоинвесторы!\n\nПролетая над бескрайними лесами России, я заметила компанию, которая превращает деревья в настоящие сокровища. Говорят, ее фабрики производят все: от прочной бумаги до красивой фанеры! Трейдеры шепчутся, что эта компания родом из карельского городка, где даже медведи знают запах свежей древесины. Догадаетесь, какой тикер у этого лесопромышленного гиганта?',
  },
  {
    cipher: 'BANE',
    keyboardSymbols: ['N', 'R', 'B', 'U', 'X', 'E', 'S', 'J', 'A'],
    tip: 'Салют, космические капитаны!\n\nПролетая над Башкирией, я заметила компанию, которая качает черное золото из недр земли. Говорят, у нее целая сеть заправок, где даже космические корабли могут подзаправиться! Трейдеры шепчутся, что ее тикер начинается как название республики, где она родилась. Догадаетесь, какой тикер у этой нефтяной компании из Уфы?',
  },
  {
    cipher: 'FIVE',
    keyboardSymbols: ['I', 'Y', 'Q', 'F', 'E', 'O', 'V', 'P', 'S'],
    tip: 'Йо-хо-хо, космические инвесторы!\n\nПролетая над торговыми центрами России, я заметила компанию, чьи магазины светятся ярче звезд. Говорят, в их супермаркетах можно найти все, от космического печенья до марсианских овощей! Трейдеры шутят, что ее тикер — это как английская «пятерка», намекая на название сети. Догадаетесь, какой тикер у этого продуктового гиганта?',
  },
  {
    cipher: 'IRAO',
    keyboardSymbols: ['Y', 'R', 'K', 'A', 'I', 'N', 'O', 'D', 'H'],
    tip: 'Хей-хо, звездные трейдеры!\n\nПролетая над энергетическими станциями России, я заметила компанию, которая освещает города ярче, чем все звезды галактики. Говорят, она может зарядить энергией даже черную дыру! Трейдеры шепчутся, что ее тикер начинается как «Интер», а заканчивается буквой, похожей на ноль. Догадаетесь, какой тикер у этого энергетического гиганта?',
  },
  {
    cipher: 'LSNG',
    keyboardSymbols: ['G', 'E', 'H', 'L', 'B', 'S', 'N', 'K', 'R'],
    tip: 'Привет, галактические инвесторы!\n\nПролетая над Северной столицей, я заметила компанию, которая освещает город ярче всех звезд на небе. Говорят, ее сети тянутся по всей Ленинградской области как серебряные нити! Трейдеры шепчутся, что ее тикер — это первые буквы от старого названия компании, когда она еще была просто «Ленэнерго». Догадаетесь, какой тикер у этого энергетического гиганта?',
  },
  {
    cipher: 'CHMF',
    keyboardSymbols: ['M', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'C'],
    tip: 'Хей-хо, звездные покорители галактик!\n\nПролетая над Череповцом, я заметила компанию, которая превращает железную руду в металл прочнее звездолета. Говорят, она может выплавить столько стали, что хватит построить космическую станцию размером с Луну! Трейдеры шепчутся, что ее тикер — это первые буквы от «Череповецкий металлургический», как местные ласково называют комбинат. Догадаетесь, какой тикер у этого стального гиганта?',
  },
  {
    cipher: 'SNGS',
    keyboardSymbols: ['Q', 'N', 'Z', 'X', 'S', 'R', 'G', 'S', 'H'],
    tip: 'Межгалактический привет, друзья!\n\nПролетая над Западной Сибирью, я заметила компанию, которая добывает черное золото в самом сердце снежных просторов. Говорят, в Сургуте даже медведи знают ее логотип наизусть! Трейдеры шепчутся, что в ее тикере спрятались первые буквы от слов «Сургут» и «нефтегаз». Догадаетесь, какой тикер у этого нефтегазового гиганта?',
  },
  {
    cipher: 'NVTK',
    keyboardSymbols: ['P', 'J', 'V', 'N', 'E', 'A', 'K', 'M', 'T'],
    tip: 'Космический салют, искатели прибыли!\n\nПролетая над Ямалом, я заметила компанию, которая превращает природный газ в жидкое космическое топливо. Говорят, она умеет так охлаждать газ, что он становится компактным, как смартфон! Трейдеры шепчутся, что эта частная компания — настоящий новатор в своем деле, и ее тикер это отражает. Догадаетесь, какой тикер у этого газового гиганта?',
  },
  {
    cipher: 'MGKL',
    keyboardSymbols: ['J', 'M', 'N', 'L', 'K', 'Z', 'O', 'D', 'G'],
    tip: 'Звездный привет, космические финансисты!\n\nПролетая над столицей, я заметила компанию, которая помогает землянам превращать свои сокровища в звонкую монету. Говорят, в ее хранилищах можно найти драгоценностей больше, чем во всех кольцах Сатурна! Трейдеры шепчутся, что в ее тикере спрятались первые буквы слов «московский городской». Догадаетесь, какой тикер у этой столичной сети ломбардов?',
  },
  {
    cipher: 'UWGN',
    keyboardSymbols: ['W', 'H', 'B', 'U', 'D', 'E', 'J', 'G', 'N'],
    tip: 'Звездный привет, друзья-инвесторы!\n\nПролетая над железнодорожными путями России, я заметила компанию, которая создает самые современные вагоны в галактике. Говорят, их колеса могут выдержать даже груз целой звезды! Трейдеры шепчутся, что эта Объединенная Вагонная Компания делает такие крутые составы, что даже инопланетяне заказывают. Догадаетесь, какой тикер у этого железнодорожного производителя?',
  },
  {
    cipher: 'MAGN',
    keyboardSymbols: ['Q', 'A', 'Z', 'M', 'S', 'G', 'I', 'N', 'K'],
    tip: 'Космический привет, звездные инвесторы!\n\nПролетая над Уралом, я заметила компанию, которая притягивает к себе успех, как магнит. Говорят, ее сталь настолько прочная, что из нее можно построить лифт до Луны! Трейдеры шепчутся, что ее тикер — это первые буквы от названия города, где расположен главный комбинат. Этот город славится своей горой и металлургией. Догадаетесь, какой тикер у этого стального гиганта?',
  },
  {
    cipher: 'POSI',
    keyboardSymbols: ['T', 'S', 'P', 'A', 'C', 'Z', 'Y', 'O', 'I'],
    tip: 'Межгалактический салют, цифровые защитники!\n\nПролетая над просторами ИТ-вселенной, я заметила компанию, которая строит невидимый щит вокруг данных землян. Говорят, ее программы могут остановить даже самых хитрых космических хакеров! Трейдеры шепчутся, что ее тикер излучает такой же позитивный настрой, как и название компании. Догадаетесь, какой тикер у этого российского киберзащитника?',
  },
  {
    cipher: 'GCHE',
    keyboardSymbols: ['E', 'H', 'K', 'F', 'M', 'C', 'Y', 'R', 'G'],
    tip: 'Галактический привет, звездные инвесторы!\n\nПролетая над российскими фермами, я заметила компанию, которая кормит пол-России вкуснее, чем в космической столовой. Говорят, ее колбасу можно найти в каждом втором холодильнике страны! Трейдеры шепчутся, что ее тикер связан с названием знаменитого московского района, где когда-то начиналась история этого мясного гиганта. Догадаетесь, какой тикер у этого продовольственного чемпиона?',
  },
];
